export const NodeEnv = import.meta.env.NODE_ENV;

// values arrive as strings; an unset one reads as undefined in development and as an empty string in the docker image
function parseIntOrDefault(value: unknown, defaultValue: number) {
  return parseInt(String(value), 10) || defaultValue;
}

export const AuthMode = ((import.meta.env.VITE_AUTH_MODE as string) || 'msal').toLowerCase();
export const BaseUrl = import.meta.env.VITE_BASE_URL as string;
export const ApiBaseUrl = import.meta.env.VITE_API_URL as string;
export const ConsentManagerId = import.meta.env.VITE_CONSENT_MANAGER_ID as string;
export const ConsentManagerEnabled = String(import.meta.env.VITE_CONSENT_MANAGER_ID).length > 0;
export const GoogleTagManagerId = import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID as string;
export const MatomoTagManagerContainer = import.meta.env.VITE_MATOMO_TAG_MANAGER_CONTAINER as string;
// String(...) is important for dynamic configuration, it's used in if condition without String(...) the else is removed as dead code during build time
export const MatomoTagManagerEnabled = String(import.meta.env.VITE_MATOMO_TAG_MANAGER_ENABLED).toLowerCase() === 'true';
export const Instance = ((import.meta.env.VITE_INSTANCE as string) || 'default').toLowerCase();
export const SupportedLanguages = ((import.meta.env.VITE_SUPPORTED_LANGUAGES as string) || 'de').split(',');
export const DocumentUploadLimit = parseIntOrDefault(import.meta.env.VITE_DOCUMENT_UPLOAD_LIMIT, 3);
export const ImageUploadLimit = parseIntOrDefault(import.meta.env.VITE_IMAGE_UPLOAD_LIMIT, 10);
export const VerificationDocumentUploadLimit = parseIntOrDefault(
  import.meta.env.VITE_VERIFICATION_DOCUMENT_UPLOAD_LIMIT,
  5
);
export const FtpServerUrl = import.meta.env.VITE_FTP_SERVER_URL;

// Hides the contact messages UI on the platforms it has not been released for yet. Enabled unless
// the variable says otherwise, so only those need to set it. String(...) as above, so the runtime
// value is read instead of being inlined at build time.
export const MessagesEnabled = String(import.meta.env.VITE_MESSAGES_ENABLED).toLowerCase() !== 'false';
